<template>
  <l-button
    :class="[
      variant === 'primary' && `
        inline-flex gap-1.5 items-center justify-center
        bg-orange hover:bg-orange-800 dark:bg-blue-700 dark:hover:bg-blue-600
        text-inherit dark:text-inherit
        hover:text-inherit dark:hover:text-inherit
        px-3 py-1
        whitespace-nowrap
      `,
      variant === 'link' && `
        inline-flex gap-1 items-center justify-center
        text-inherit dark:text-inherit
        hover:text-inherit dark:hover:text-inherit hover:underline
        whitespace-nowrap
      `,
      'rounded',
    ]"
    rel="nofollow noopener"
    :target="popout ? '_blank' : '_parent'"
  >
    <slot/>
  </l-button>
</template>

<script setup>
import LButton from "@/components/buttons/LButton.vue"

defineProps({
  variant: { type: String, default: "link" },
})

const popout = !!window.opener
</script>
